export class EmailTemplateApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCategories({ include, skipForbiddenError }) {
    return this.#http.get('/api/email-template-categories', {
      params: { include },
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async createCategory(body) {
    return this.#http.post('/api/email-template-categories', body);
  }

  async deleteCategory({ emailTemplateCategoryId }) {
    return this.#http.delete(`/api/email-template-categories/${emailTemplateCategoryId}`);
  }

  async getTemplates({ include }) {
    return this.#http.get('/api/email-template-categories', { params: { include } });
  }

  async createTemplate({ emailTemplateCategoryId, name }) {
    return this.#http.post(
      `/api/email-template-categories/${emailTemplateCategoryId}/email-templates`,
      {
        categoryId: emailTemplateCategoryId,
        name,
      },
    );
  }

  async getTemplate({ emailTemplateCategoryId, emailTemplateId, include }) {
    return this.#http.get(
      `/api/email-template-categories/${emailTemplateCategoryId}/email-templates/${emailTemplateId}`,
      { params: { include } },
    );
  }

  async deleteTemplate({ emailTemplateId, emailTemplateCategoryId }) {
    return this.#http.delete(
      `/api/email-template-categories/${emailTemplateCategoryId}/email-templates/${emailTemplateId}`,
    );
  }

  async editTemplate({ categoryId, templateId, body }) {
    return this.#http.put(
      `/api/email-template-categories/${categoryId}/email-templates/${templateId}`,
      body,
    );
  }

  async uploadFile({ categoryId, templateId, formData }) {
    return this.#http.post(
      `/api/email-template-categories/${categoryId}/email-templates/${templateId}/resources`,
      formData,
      { 'Content-Type': 'multipart/form-data' },
    );
  }
}
